import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams, Platform } from '@ionic/angular';
import { fromEvent } from 'rxjs';
import { Navigator } from 'src/app/components/menu/navigator';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { EventsService } from 'src/app/services/event/event.service';
import { gsap } from 'gsap';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { AudioService } from 'src/app/services/audio/audio.service';
//Paid plugin added. Do not comment below plugins. You just need to remove node_modules and have to do npm i again.
import { MotionPathHelper } from 'gsap/MotionPathHelper'; // Import the MotionPathPlugin
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { UtilsService } from 'src/app/services/utils/utils.service';
gsap.registerPlugin(MotionPathHelper, MotionPathPlugin); // Register the MotionPathPlugin

@Component({
  selector: 'app-rocket-bonus-game-launch',
  templateUrl: './rocket-bonus-game-launch.component.html',
  styleUrls: ['./rocket-bonus-game-launch.component.scss'],
})

export class RocketBonusGameLaunchComponent implements OnInit {
  @ViewChild('rocketContent') rocketContent: ElementRef;
  private slotUrl;
  private subscriber3: any;
  private dailyWheelParams: any;
  private shouldShowCoinAnimation: boolean = true;
  private boxCounter: number = 1;
  private isMobile: boolean = false;
  private isPortrait: boolean = false;
  private closeTimeout: any;
  public pathCoordinates: string;
  public viewBox: string;
  public showRocketGame: boolean = false;
  private isIOSApp: boolean = false;
  constructor(
    public navParams: NavParams,
    private bonusService: BonusService,
    public navigator: Navigator,
    private el: ElementRef,
    private platform: Platform,
    private balanceProvider: AccountBalanceService,
    public eventService: EventsService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private utils: UtilsService,
    private audioService: AudioService
  ) {

    this.adjustCSSForMobile();
    this.isIOSApp = this.platform.is('capacitor') && this.platform.is("ios");
  }

  ngOnInit() {
    this.dailyWheelParams = this.navParams.get("gameData");
    this.updateRocketAnimationSVGPath();
    this.getRocketBonusDisplayContentElements();

    setTimeout(() => {
      this.doRocketElementMotionPathHelper();
    }, 300);
   
    this.subscriber3 = fromEvent(window, 'message')
      .subscribe((event) => {
        this.oniFrameMessage(event);
      });
  }

  startRocketWheelCall(){
    let url = this.bonusService.getUrl(this.dailyWheelParams);
    this.slotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.audioService.stopMusic();
    this.audioService.playSound("RocketWheelSequence_music");
  }

  ngOnDestroy() {
    this.subscriber3.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    setTimeout(() => {
      this.adjustCSSForMobile();
      this.updateRocketAnimationSVGPath();
    }, 500);
  }

  adjustCSSForMobile() {
    this.isMobile = this.platform.is('mobile');
    this.isPortrait = this.platform.isPortrait();
  }

  updateRocketAnimationSVGPath() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const newViewBox = `0 0 ${screenWidth} ${screenHeight}`;

    const element = document.querySelector('.footer-bonus-rocket-part');
    const rect = element?.getBoundingClientRect();
    if(rect) {
      const xPosition = rect.left + window.scrollX;
      const yPosition = rect.top + window.scrollY;
      this.renderer.setAttribute(document.getElementById('motionPath'), 'viewBox', newViewBox);
      this.viewBox = newViewBox;
      if (this.platform.is('mobile') && this.platform.isPortrait()) {
        this.pathCoordinates = `M ${xPosition + 5} ${(yPosition + 17)} C120.02733,312.58746 346.251,175.484 312.953,142.193 144.953,146.079 -1.542,474.145 31.819,540.851 365.135,574.139 454.805,522.205 454.281,523.969`
      } else {
        this.pathCoordinates = `M ${xPosition + 5} ${(yPosition + 17)} Q 150 ${(screenWidth < 768 ? 100 : 50)} 100 50 Q 0 ${(screenWidth < 768 ? 50 : 100)} 50 ${(screenWidth < 768 ? 150 : 250)} Q 550 ${(screenWidth < 768 ? 200 : 300)} ${(screenWidth ? screenWidth + 50 : screenWidth + 50)} 150`;
      }
    }
  }


  getRocketBonusDisplayContentElements() {
    const rocketText = this.el.nativeElement.querySelector('.rocket-text');
    const rocketSkip = this.el.nativeElement.querySelector('.rocket-skip');
    const spinBonus = this.el.nativeElement.querySelector('#spin-bonus');
    const plusSign = this.el.nativeElement.querySelector('#plus-sign');
    const streakBonus = this.el.nativeElement.querySelector('#streak-bonus');
    const bonusTotalRow = this.el.nativeElement.querySelector('.bonus-total-row');
    const collectSelector = this.el.nativeElement.querySelector('.collect-selector');
    rocketText.style.opacity = 0;
    rocketSkip.style.opacity = 0;
    spinBonus.style.opacity = 0;
    plusSign.style.opacity = 0;
    streakBonus.style.opacity = 0;
    bonusTotalRow.style.opacity = 0;
    collectSelector.style.opacity = 0;
  }

  getRocketBonusTotal() {
    let spin_bonus = Number(this.dailyWheelParams.spin_grant);
    let streak_grant = Number(this.dailyWheelParams.streak_grant);
    return spin_bonus + streak_grant;
  }

  adjustIonAppOpacity() {
    const ionPage: HTMLIonAppElement = document.querySelector('.ion-page');
    ionPage.classList.remove('overlay');
  }

  oniFrameMessage(event) {
    if (!isUndefined(event.data) && !isUndefined(event.data.name)) {
      switch (event.data.name) {
        case "startRocketWheel":

          this.audioService.playSound("RocketWheelSpinning");
          gsap.delayedCall(2.5, () => { this.audioService.fadeSound("RocketWheelSpinning", 1, 0, 1000); })
          break;
        case "completeRocketWheel":
          setTimeout(() => {
            this.animateRocketBonusInformation();
          }, 600);

          this.closeTimeout = setTimeout(() => {
            this.onCollect()
          }, 15000);

          break;
      }
    }
  }

  onCollect() {
    clearTimeout(this.closeTimeout);

    this.collectCoins();

    setTimeout(() => {
      this.closeRocketBonus();
    }, 2000);
  }

  closeRocketBonus() {
    this.balanceProvider.updateBalance();
    this.adjustIonAppOpacity();
    this.navigator.dismiss();
    this.eventService.publish('event:call:rocketLaunch:timer');

    this.audioService.playMusic("BGMusic");
  }

  animateRocketBonusInformation() {
    const popOutAnimationProps = { y: '-100%', opacity: 0, scale: 0, ease: 'power4.out' };

    const rocketText = this.el.nativeElement.querySelector('.rocket-text');
    const rocketSkip = this.el.nativeElement.querySelector('.rocket-skip');
    const spinBonus = this.el.nativeElement.querySelector('#spin-bonus');
    const plusSign = this.el.nativeElement.querySelector('#plus-sign');
    const streakBonus = this.el.nativeElement.querySelector('#streak-bonus');
    const bonusTotalRow = this.el.nativeElement.querySelector('.bonus-total-row');
    const collectSelector = this.el.nativeElement.querySelector('.collect-selector');

    gsap.fromTo(rocketText, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 0.5, delay: 0.1 });
    gsap.fromTo(rocketSkip, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 0.5, delay: 0.1 });
    gsap.fromTo(spinBonus, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 1, delay: 1, onStart:()=>{this.audioService.playSound("RocketWheelSequence_bonusappear");} });
    gsap.fromTo(plusSign, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 1, delay: 2 });
    gsap.fromTo(streakBonus, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 1, delay: 3, onStart:()=>{this.audioService.playSound("RocketWheelSequence_bonusappear");}  });
    gsap.fromTo(bonusTotalRow, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 1, delay: 4 });
    gsap.fromTo(collectSelector, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, duration: 1, delay: 4.5, onStart:()=>{this.audioService.playSound("RocketWheelSequence_collectbutton");}, onComplete:()=> {rocketSkip.style.opacity = '0';} });
    
  
  }

  skipAnimation(){
    const popOutAnimationProps = { y: '-100%', opacity: 0, scale: 0, ease: 'power4.out' };
    const rocketSkip = this.el.nativeElement.querySelector('.rocket-skip');
    const spinBonus = this.el.nativeElement.querySelector('#spin-bonus');
    const plusSign = this.el.nativeElement.querySelector('#plus-sign');
    const streakBonus = this.el.nativeElement.querySelector('#streak-bonus');
    const bonusTotalRow = this.el.nativeElement.querySelector('.bonus-total-row');
    const collectSelector = this.el.nativeElement.querySelector('.collect-selector');
    gsap.killTweensOf(plusSign)
    gsap.killTweensOf(streakBonus)
    gsap.killTweensOf(bonusTotalRow)
    gsap.killTweensOf(collectSelector)
    gsap.fromTo(spinBonus, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, onStart:()=>{this.audioService.playSound("RocketWheelSequence_bonusappear");} });
    gsap.fromTo(plusSign, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1 });
    gsap.fromTo(streakBonus, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, onStart:()=>{this.audioService.playSound("RocketWheelSequence_bonusappear");}  });
    gsap.fromTo(bonusTotalRow, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, });
    gsap.fromTo(collectSelector, { ...popOutAnimationProps }, { y: '0%', opacity: 1, scale: 1, onStart:()=>{this.audioService.playSound("RocketWheelSequence_collectbutton");}, onComplete:()=> {rocketSkip.style.opacity = '0';} });
  }

  collectCoins() {
    if (this.shouldShowCoinAnimation) {

      this.shouldShowCoinAnimation = false;
      this.audioService.playSound("BonusCollect");

      const hourlybonus: any = document.querySelector('.bonus-total-row');
      const coinbar: any = document.querySelector('.navbar-shop-container-coin-animation');
      const startRect = hourlybonus.getBoundingClientRect();
      const container = document.querySelector('.coin-animation-for-rocket');
      const endRect = coinbar.getBoundingClientRect();
      const verticalSpaceiOS = 48;
      for (let i = 0; i < 25; i++) {
        const coin = this.createCoin(container);
        const addMore = (startRect.x <= 300) ? 67 : startRect.x / 2.8
        const startX = startRect.x + addMore;
        //const startY = startRect.y + 10;
        const startY = (this.isIOSApp && (endRect.y > verticalSpaceiOS)) ? startRect.y - verticalSpaceiOS : startRect.y + 10;
        const endX = endRect.x
        //const endY = endRect.y
        const endY = (endRect.y > verticalSpaceiOS) ? verticalSpaceiOS : endRect.y

        const radiusX = 100;
        const radiusY = 60;
        const rndX = gsap.utils.random(-radiusX, radiusX, 1);
        const rndY = gsap.utils.random(-radiusY, radiusY, 1);

        gsap.set(coin, {
          x: startX,
          y: startY
        });

        gsap.to(coin, {
          duration: 0.4,
          x: startX + rndX,
          y: startY + rndY,
          ease: 'none',
        });

        gsap.to(coin, {
          duration: 0.8,
          delay: 0.1 + i * 0.01,
          x: endX + 3,
          y: endY,
          ease: 'back.in(0.5)',
          onComplete: () => {
            container.removeChild(coin);
          }
        });
      }
    }
  }

  createCoin(div) {
    let box: any = document.createElement("div");
    box.classList.add('box');
    box.innerHTML = `<div class="center">
                        <img src="assets/images/chip.svg" alt="coin">
                    </div>`
    box.style.zIndex = 1000 + this.boxCounter;
    div.appendChild(box);
    this.boxCounter = this.boxCounter > 1000 ? 1 : this.boxCounter++;
    return box;
  }

  doRocketElementMotionPathHelper(params? : any){
    const rocketString = document.querySelector('.footer-bonus-rocket-string') as HTMLElement;
    const rocketSpark = document.querySelector('.footer-bonus-rocket-fuse') as HTMLElement;
    rocketString.style.opacity = '0';
    rocketSpark.style.opacity = '0';
    const getRocketPathFromApp = document.querySelector('.rocket-motion-section') as HTMLElement;
    getRocketPathFromApp.style.display = 'block';
    const findRocketPart = document.querySelector('.footer-bonus-rocket-container-animated') as HTMLElement;
    findRocketPart.style.display = 'flex';
    const rocketElement = document.querySelector('.footer-bonus-rocket-main') as HTMLElement ;
    const svgPath = document.querySelector('#path') as SVGPathElement;


    const rocketAnimationTimeLine = gsap.timeline();

    const rocketContextSetup = gsap.set(rocketElement, { scale:1.1, autoAlpha: 1 });

    const animationDuration = 2;
    const initialScale = 1.1; 
    const finalScale = 2; 
    const start = 0.0;
    const end = 0.3;
    const rocketContext = gsap.to(rocketElement, {
      duration: animationDuration,
      ease: "power1.inOut",
      immediateRender: true,
      motionPath: {
        path: svgPath,
        align: svgPath,
        alignOrigin: [0.5, 0.5],
        autoRotate: 70,
        start: start,
        end: end
      },
      paused:false,
      zIndex: 999,
      alignContent: 'center',
      scale: initialScale, // Initial scale
      onUpdate: ()=> {
      },
      onStart: ()=> {
        rocketElement.style.scale = '1.1';
        this.audioService.playSound("RocketWheelSequence_rocket1_start");
      },
      onComplete: ()=> {
        console.log('Animation completed: Part 1');
      }
    });

    const rocketContext2 = gsap.to(rocketElement, {
      duration: 3,
      ease: "power1.inOut",
      immediateRender: true,
      motionPath: {
        path: svgPath,
        align: svgPath,
        alignOrigin: [0.5, 0.5],
        autoRotate: 70,
        start: 0.299,
        end: 1
      },
      alignContent: 'center',
      zIndex: 999,
      paused:false,
      scale: 3,
      onUpdate: ()=> {
      },
      onStart: ()=> {
        rocketElement.style.scale = '1.1';
        this.audioService.playSound("RocketWheelSequence_rocket2_end");
      },
      onComplete: ()=> {
        console.log('Animation completed: Part 2');
        //Animation Cleanup
        const getRocketPathFromApp = document.querySelector('.rocket-motion-section') as HTMLElement;
        getRocketPathFromApp.style.display = 'none';
        const findRocketPart = document.querySelector('.footer-bonus-rocket-container-animated') as HTMLElement;
        findRocketPart.style.display = 'none';
        rocketContext2.kill();
        this.showRocketGame = true;
        this.startRocketWheelCall();
      }
    });

   MotionPathHelper.create(rocketElement, {
    selected: false,
    path: svgPath,
    ease: 'power1.inOut'
   });

   rocketContext.repeat(0);
   rocketContext2.repeat(0);
   rocketAnimationTimeLine.add(rocketContextSetup);
   rocketAnimationTimeLine.add(rocketContext);
   rocketAnimationTimeLine.add(rocketContext2);
   rocketAnimationTimeLine.play();
  
  }


}
